import React from "react"
import { Grid } from "@mui/material"
import { WBInput } from "components/_WBcomponents/WBInput"
import { WBLabel, WBTitleLabel } from "components/_WBcomponents/WBLabel"
import moment from "moment"
import { NumericFormat } from "react-number-format"

function ExpenseDetail ({
    data
}) {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} lg={12} spacing={1}>
                <WBLabel style={{fontWeight: 'bold', fontSize: 16}}>Expense Detail</WBLabel>
            </Grid>
            <Grid item xs={12} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBInput label={"Expense Type"} disabled value={data.expenseType ? data.expenseType.name : ''}/>
                </Grid>
            </Grid>
            <Grid item xs={12} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBInput label={"Event"} disabled value={data.eventId ? data.eventId.eventName : ''}/>
                </Grid>
            </Grid>
            <Grid item xs={6} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBInput label={"Request By"} disabled value={data.requestBy ? data.requestBy.name : ''}/>
                </Grid>
            </Grid>
            <Grid item xs={6} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBInput label={"Expense Date"} disabled value={moment(data.expenseDate).format('YYYY-MM-DD')}/>
                </Grid>
            </Grid>
            <Grid item xs={12} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBLabel style={{
                        color: "rgb(133, 133, 133)"
                    }}>Nominal</WBLabel>
                    <NumericFormat value={data.nominal}
                        isAllowed={false}
                        disabled={true}
                        decimalScale={0}
                        allowLeadingZeros={false}
                        allowedDecimalSeparators={false}
                        allowNegative={false}
                        thousandSeparator
                        customInput={WBInput}
                    />
                </Grid>
            </Grid>
            <Grid item mt={1} xs={12} md={12}>
                <WBLabel bold style={{
                    color: 'rgb(133, 133, 133)'
                }}>Proof Image</WBLabel>
                <Grid item container mt={1}>
                {
                    data.imageProof && data.imageProof.map( v => {
                        return (
                            <Grid item>
                                <img src={v} width={200} height={200}/>
                            </Grid>
                        )
                    })
                }
                </Grid>
            </Grid>
            <Grid item xs={12} lg={12} spacing={1}>
                <Grid item xs={12}>
                    <WBInput type={"textarea"} label={"Remarks"} disabled value={data.description}/>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ExpenseDetail    